const TEMPLATE_NAME = 'PRESCRIPTION';

const initialState = () => ({
  loading: false,
  loadedData: [],
  filters: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      return {
        ...state,
        loading: false,
        loadedData: action.payload,
        filters: {
          ...state.filters,
          data: action.payload
        }
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
